import React from 'react';

type Props = {
  size?: number;
};

const TransparentLoader: React.FC<Props> = ({ size = 3 }) => {
  return (
    <div className="absolute z-50 top-0 left-0 flex items-center justify-center w-full h-full p-5 min-w-screen bg-white bg-opacity-50">
      <div className="flex space-x-2 animate-pulse">
        <div className={`w-${size} h-${size} bg-gray-500 rounded-full`}></div>
        <div className={`w-${size} h-${size} bg-gray-500 rounded-full`}></div>
        <div className={`w-${size} h-${size} bg-gray-500 rounded-full`}></div>
      </div>
    </div>
  );
};

export default TransparentLoader;
